/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["form[_ngcontent-%COMP%]{margin:12px}mat-form-field[_ngcontent-%COMP%]{width:100%;margin-bottom:10px}.spinner[_ngcontent-%COMP%]{display:inline-block}.spinner-container[_ngcontent-%COMP%]{text-align:center}@media screen and (min-width:450px){form[_ngcontent-%COMP%]{margin:0 12px 12px}}@media screen and (min-width:650px){form[_ngcontent-%COMP%]{margin:0 0 12px;width:100%;text-align:center}mat-form-field[_ngcontent-%COMP%]{max-width:400px}button[_ngcontent-%COMP%]{margin-left:20px}}"];
export { styles as styles };
